import React, { useState } from 'react'
import { Alert, Box, Button, Checkbox, FormHelperText, Grid2, IconButton, Link, MobileStepper, Tab, Tabs, TextField, ThemeProvider, Typography, createTheme, styled, useTheme } from '@mui/material'
import patternLogo from "../../assets/images/pattern.png"
import { FaCircleCheck, FaRegFileLines } from 'react-icons/fa6';
import { FaCircle } from 'react-icons/fa';
import { CiCircleCheck } from "react-icons/ci";
import DragAndDropUpload from '../../components/FileUploader/DragAndDropUpload';
import SnackbarComponent from '../../components/SplashScreen/SnackbarComponent';
import { useNavigate } from 'react-router-dom';
import { closeSnackbar, openSnackbar } from '../../store/slices/snackbar';
import { useDispatch } from '../../store';
import { useThemeContext } from 'components/ui-components/ThemeContext';
import { useAddCompanyMutation } from 'store/slices/apis/apiSlice';
import { DEFAULT_THEME_COLOR } from 'config';
import { RxCross1 } from 'react-icons/rx';


const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "16px",
    color: "#696969",
    padding: '0px 10px',
    minHeight: '0px',
    cursor: 'auto',
    "&.Mui-selected": {
        color: "#696969", // Selected tab color
    },
    "&.Mui-disabled": {
        color: "#696969", // Selected tab color
    },

}));



const colors = [
    "#C05222",
    "#415385",
    "#3E756D",
    "#C84757",
    "#CE412D",
    "#2D2D2D",
];


const intitalFormError = {
    'SPOC_name': "",
    'SPOC_email': "",
    'SPOC_phoneno': "",
    'tenantName': "",
    'tenantEmail': "",
    'tenantPhone': ""
};
const SignUp = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const newtheme = useTheme();
    const { setBgColor } = useThemeContext()
    const [activeStep, setActiveStep] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isSameAddress, setIsSameAddress] = useState(false);
    const [productKeyErrorMessage, setProductKeyErrorMessage] = useState(null);
    const [fromError, setFormError] = useState({ ...intitalFormError });
    const [organisationErrors, setOrganisationErrors] = useState({});

    const [addCompany, { data, isLoading, isSuccess, isError, error }] = useAddCompanyMutation();



    const theme = createTheme({
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        backgroundColor: `${newtheme?.customSettings?.themeColor}`, color: '#FFF', padding: '6px 20px', fontWeight: '500', textTransform: 'none', fontSize: '16px', float: 'right', marginTop: '30px',
                        '&.Mui-disabled': {
                            color: '#fff',
                            fontSize: '16px'
                        }
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        border: '2px solid #e6e6e6', '& .MuiFilledInput-input': {
                            backgroundColor: '#fff',
                            color: '#252525',
                            fontSize: '16px'
                        },
                        '& .MuiFilledInput-root::before': {
                            borderBottom: 'none'
                        },
                        '& .MuiFilledInput-root::after': {
                            borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#696969',
                            fontSize: '14px'
                        },
                        '& .MuiFormLabel-root': {
                            fontSize: '14px'
                        },
                        '& .MuiFilledInput-root.Mui-disabled:before': {
                            borderBottom: 'none'
                        }
                    },
                },
            }
        },
    });

    // const mutation = useMutation(fetchPostData);

    const [organisationDetail, setOrganisationDetail] = useState({
        'admin_name': "",
        'image': null,
        'theme_color': DEFAULT_THEME_COLOR
    });

    const [administratorInfo, setAdministratorInfo] = useState({
        'SPOC_name': "",
        'SPOC_email': "",
        'SPOC_phoneno': "",
        'tenantName': "",
        'tenantEmail': "",
        'tenantPhone': ""
    });

    const maxCharacters = 24;

    const [value, setValue] = useState("");

    const isInvalid = value.replace(/\s+/g, "").length > maxCharacters;

    const handleDrop = (acceptedFiles, rejectedFiles) => {

        if (rejectedFiles.length > 0) {
            openNotification("File type must be image/*");
            return;
        }
        setSelectedFile(acceptedFiles[0]?.name);
        setOrganisationDetail((prevState) => ({
            ...prevState,
            'image': acceptedFiles
        }));

        if (organisationErrors?.image) {
            setOrganisationErrors((prevState) => ({
                ...prevState,
                'image': ''
            }));
        }
    };

    const formatValue = (input) => {
        // Remove existing spaces
        const rawValue = input.replace(/\s+/g, "");
        // Limit the input to `maxCharacters`
        const trimmedValue = rawValue.substring(0, maxCharacters);
        // Insert a space after every 4 characters
        return trimmedValue
            .match(/.{1,4}/g) // Split into groups of 4
            ?.join(" ") || ""; // Join with spaces
    };

    const handleChange = (event) => {
        // const formattedValue = formatValue(event.target.value);
        // setValue(formattedValue);

        let inputValue = event.target.value.replace(/\s/g, "");

        let formattedValue = inputValue.replace(/(.{4})/g, "$1 ").trim();
        setValue(formattedValue);
        if (productKeyErrorMessage) {
            setProductKeyErrorMessage(null)
        }
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1.1);
    };

    const handleRedirect = () => {
        navigate('/login', { replace: true });
    }


    const handleValidateProductKey = () => {

        let charCount = value.replace(/\s/g, "").length;
        if (charCount == 0) {
            setProductKeyErrorMessage('Product key field is required.');
        } else if (charCount > maxCharacters) {
            setProductKeyErrorMessage('The product key you entered is invalid. Note: It exceeds the maximum length of 24 digits.');
        } else if (charCount < maxCharacters) {
            setProductKeyErrorMessage('The product key you entered is invalid. Note: Its maximum length is less than 24 digits.');
        } else {
            setProductKeyErrorMessage(null);
            setActiveStep((prevActiveStep) => prevActiveStep + 1.4);
        }
    }



    const validateOrganisationForm = () => {
        let newErrors = {};

        if (!organisationDetail?.admin_name.trim()) {
            newErrors.admin_name = "Organisation name field is required.";
        }

        if (!organisationDetail?.image) {
            newErrors.image = "Organisation logo field is required.";
        }

        if (!organisationDetail?.theme_color) {
            newErrors.theme_color = "Primary color field is required.";
        }

        setOrganisationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input change
    const handleChangeOrganisation = (event) => {
        const { name, value } = event.target;
        setOrganisationDetail((prevState) => ({
            ...prevState,
            [name]: value
        }));

        if (organisationErrors?.admin_name) {
            setOrganisationErrors((prevState) => ({
                ...prevState,
                'admin_name': ''
            }));
        }

    };

    const handleValidateAdministratorBlur = (event, keyName) => {
        const { name, value } = event.target;
        validateField(name, value, keyName);
    };

    const validateField = (name, value, keyName) => {
        const phoneRegex = /^\+\d{10,15}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let error = "";

        if (!value?.trim()) {
            error = `${keyName} field is required.`;
        } else {
            switch (name) {
                case "SPOC_email":
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        error = "Please enter a valid email address";
                    }
                    break;
                case "SPOC_phoneno":
                    if (!phoneRegex.test(value)) {
                        error = "Phone Number must start with + and be 10 to 15 digits long";
                    }
                    break;

                case "tenantEmail":
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        error = "Please enter a valid email address";
                    }
                    break;
                case "tenantPhone":
                    if (!phoneRegex.test(value)) {
                        error = "Phone Number must start with + and be 10 to 15 digits long";
                    }
                    break;
                default:
                    break;
            }
        }

        setFormError((prev) => ({ ...prev, [name]: error }));
        return error;
    };



    const handleValidateAdministratorInfo = () => {
        const validateFields = ["SPOC_name", "SPOC_email", "SPOC_phoneno", "tenantName", "tenantEmail", "tenantPhone"];
        const keyFields = ["Full Name", "Work Email", "Phone Number", "Full Name", "Work Email", "Phone Number"];
        let errors = {};
        let isValid = true;

        validateFields.forEach((field,key) => {
            const error = validateField(field, administratorInfo[field],keyFields[key]);
            if (error) {
                isValid = false;
            }
        });
    
        return isValid;
    };


    const handleSelectPrimaryColor = (color) => {
        setBgColor(color);
        setOrganisationDetail((prevState) => ({
            ...prevState,
            'theme_color': color === organisationDetail?.theme_color ? null : color
        }));
    }

    const handleSubmitOrganisation = () => {

        if (validateOrganisationForm()) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleAdministratorInfo = (event) => {
        const { name, value } = event.target;
        setAdministratorInfo((prevState) => ({
            ...prevState,
            [name]: value
        }));

        if (isSameAddress) {
            setAdministratorInfo((prevState) => ({
                ...prevState,
                tenantName: prevState.SPOC_name,
                tenantEmail: prevState.SPOC_email,
                tenantPhone: prevState.SPOC_phoneno,
            }));
        }

    }

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };

    // Handle checkbox change
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        if (checked) {
            setFormError({
                ...fromError,
                'tenantName': '',
                'tenantEmail': '',
                'tenantPhone': '',
            });

        }
        setIsSameAddress(checked);
        setAdministratorInfo((prevState) => ({
            ...prevState,
            tenantName: checked ? prevState.SPOC_name : '',
            tenantEmail: checked ? prevState.SPOC_email : '',
            tenantPhone: checked ? prevState.SPOC_phoneno : '',
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (handleValidateAdministratorInfo()) {
            let updatedData;
            if (isSameAddress) {
                let updateAdministratorData = {
                    ...administratorInfo,
                    tenantName: administratorInfo?.SPOC_name,
                    tenantEmail: administratorInfo?.SPOC_email,
                    tenantPhone: administratorInfo?.SPOC_phoneno
                }

                updatedData = { ...organisationDetail, ...updateAdministratorData };
            } else {
                updatedData = { ...organisationDetail, ...administratorInfo };
            }
            const formData = new FormData();

            Object.keys(updatedData).forEach((key) => {
                formData.append(key, updatedData[key]);
            });

            try {
                const response = await addCompany(formData).unwrap();
                if (response?.status == 'success') {
                    openNotification(response?.message, 'success');
                    setActiveStep((prevActiveStep) => prevActiveStep + 0.5);
                } else {
                    openNotification(response?.message);
                }
            } catch (err) {
                openNotification(err?.message);
            }
        }

    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <Box>
                    <Grid2 container>
                        <Grid2 size={12}>
                            <Typography
                                variant="h2"
                                gutterBottom
                                textAlign={"center"}
                                style={{ color: '#696969', fontWeight: "400", marginBottom: '0px', marginTop: '40px', fontSize: "45px", opacity: '0.7' }}
                            >
                                Setup Your Workspace
                            </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 4 }} offset={{ md: 4 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    mt: 2,
                                    alignItems: "center", // Center align tabs and stepper
                                    width: "100%", // Ensures it scales properly
                                }}
                            >
                                {/* Wrapper for Tabs and MobileStepper to sync width */}
                                <Box sx={{ width: "fit-content", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Tabs
                                        aria-label="basic tabs example"
                                        centered
                                        sx={{
                                            minHeight: "0px",
                                            "& .MuiTabs-indicator": { display: "none" },
                                        }}
                                        value="1"
                                    >
                                        <StyledTab label="Product key" disabled value="1" sx={{ paddingLeft: '0px' }} />
                                        <StyledTab label="Organisation" disabled value="2" />
                                        <StyledTab label="Administrator" disabled value="3" sx={{ paddingRight: '0px' }} />
                                    </Tabs>

                                    {/* Stepper with width matching Tabs */}
                                    <MobileStepper
                                        variant="progress"
                                        steps={5}
                                        position="relative"
                                        activeStep={activeStep}
                                        sx={{
                                            width: "100%", // Matches Tabs width
                                            flexGrow: 1,
                                            background: "none",
                                            padding: "0px",
                                            justifyContent: "center",
                                            mt: 1,
                                            "& .MuiLinearProgress-root": {
                                                backgroundColor: "#E8E8E8", // Line background color
                                                borderRadius: "2px",
                                                height: "3px",

                                            },
                                            "& .MuiMobileStepper-progress": {
                                                width: '100%'
                                            },
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: `${newtheme?.customSettings?.themeColor}`, // Change to your theme color
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid2>
                        {activeStep === 0 &&
                            <Grid2 size={{ xs: 12, md: 8 }} offset={{ md: 2 }} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', // Centers items horizontally
                                justifyContent: 'center', // Centers items vertically
                                textAlign: 'center', // Aligns text center'
                                mt: 4
                            }}>
                                <img
                                    srcSet={`${patternLogo}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${patternLogo}?w=164&h=164&fit=crop&auto=format`}
                                    alt={'pattern'}
                                    loading="lazy"
                                    style={{ width: '85%', marginBottom: '20px' }} // Ensure the image fills the container
                                />
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    textAlign={"center"}
                                    sx={{
                                        m: 0
                                    }}
                                    style={{ color: '#252525', fontWeight: "400", fontSize: '20px' }}
                                >
                                    Welcome, <span style={{ fontWeight: '600' }}>Administrator</span>
                                </Typography>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    textAlign={"center"}
                                    sx={{
                                        m: 0
                                    }}
                                    style={{ color: '#252525', fontWeight: "400", fontSize: '20px' }}
                                >
                                    set up your <span style={{ fontWeight: '600' }}>Project</span> Management & Analysis Tool
                                </Typography>

                                <Button onClick={handleNext}>
                                    Let's get started
                                </Button>
                            </Grid2>
                        }
                        {activeStep === 1.1 &&
                            <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                <Typography
                                    variant="h3"
                                    gutterBottom
                                    sx={{
                                        mt: 4
                                    }}
                                    style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px" }}
                                >
                                    Product Key
                                </Typography>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginBottom: "20px", textAlign: 'justify' }}
                                >
                                    Please provide the 24 digits product key that was sent to you by the PWC team. This will assist us in validating your product. <Link href="#" sx={{ color: `${newtheme?.customSettings?.themeColor}` }}>Note: Contact "XXXXX" at XXXXX.l&t.com.</Link>
                                </Typography>
                                <Box sx={{ position: "relative", marginBottom: "10px" }}>
                                    <TextField
                                        label="Product Key"
                                        placeholder="Ex: BB23 7786 2749 9DAA ZZ56 8890"
                                        variant="filled"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        fullWidth
                                        value={value}
                                        onChange={handleChange}
                                    // error={value.replace(/\s+/g, "").length > maxCharacters}
                                    // helperText={
                                    //     value.replace(/\s+/g, "").length > maxCharacters
                                    //         ? "The product key you entered is invalid. Note: It exceeds the maximum length of 24 characters."
                                    //         : ""
                                    // }
                                    />
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            position: "absolute",
                                            right: 10,
                                            top: "30%",
                                            transform: "translateY(-50%)",
                                            pointerEvents: "none",
                                            color: isInvalid ? "red" : "gray",
                                            fontSize: '12px'
                                        }}
                                    >
                                        {value.replace(/\s+/g, "").length} / {maxCharacters}
                                    </Typography>
                                    {productKeyErrorMessage &&
                                        <Typography variant="body1" sx={{ fontSize: '12px', color: '#C52A1A', mt: 1, fontWeight: 400, }}>
                                            {productKeyErrorMessage}
                                        </Typography>
                                    }

                                </Box>
                                <Button onClick={handleValidateProductKey}>
                                    Validate Product Key
                                </Button>
                                <Button onClick={() => {
                                    setActiveStep(0)
                                    setValue("")
                                    setProductKeyErrorMessage(null)
                                }} variant='outlined' sx={{
                                    marginRight: '20px',
                                    color: `${newtheme?.customSettings?.themeColor}`,
                                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                    background: 'none'
                                }}>
                                    Back
                                </Button>
                            </Grid2>
                        }
                        {activeStep === 2.5 &&
                            <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                <Typography
                                    variant="h3"
                                    gutterBottom
                                    sx={{
                                        mt: 4
                                    }}
                                    style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px" }}
                                >
                                    Organisation Info
                                </Typography>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', textAlign: 'justify' }}
                                >
                                    Enter your business name along with logo, and pick a primary colour from the options below to personalise the application's appearance across all app users. 
                                    {/* <Link href="#" sx={{ color: newtheme?.customSettings?.themeColor }}>Hint: Use Brand Colour</Link> */}
                                </Typography>
                                <TextField
                                    label="Organisation name"
                                    variant="filled"
                                    name='admin_name'
                                    fullWidth
                                    placeholder="Ex: Royal BAM Group nv"
                                    value={organisationDetail?.admin_name}
                                    onChange={handleChangeOrganisation}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                                {organisationErrors?.admin_name &&
                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${organisationErrors?.admin_name}`}</FormHelperText>
                                }

                                <Box sx={{ width: "100%", mt: 3 }}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        style={{ color: '#696969', fontWeight: "500", fontSize: '20px' }}
                                    >
                                        Upload Your Organisation Iogo
                                    </Typography>



                                    {selectedFile ?
                                        <>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                style={{ color: '#474747', fontWeight: "400", fontSize: '16px' }}
                                            >
                                                You have uploaded your logo successfully. <span style={{ color: `${newtheme?.customSettings?.themeColor}`, cursor: 'pointer', textDecoration: "underline" }} onClick={() => {
                                                    setSelectedFile(null);
                                                    setOrganisationDetail((prevState) => ({
                                                        ...prevState,
                                                        'image': null
                                                    }));
                                                }}>Change this logo.</span>
                                            </Typography>
                                            <Alert
                                                sx={{
                                                    backgroundColor: '#fff',
                                                    width: '82%',
                                                    '& .MuiAlert-message': {
                                                        fontSize: '16px',
                                                        color: '#252525'
                                                    }
                                                }}
                                                icon={<FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />} // Custom icon
                                                action={
                                                    <IconButton
                                                        aria-label="close"
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedFile(null);
                                                            setOrganisationDetail((prevState) => ({
                                                                ...prevState,
                                                                'image': null
                                                            }));
                                                        }}
                                                    >
                                                        <RxCross1 fontSize="large" style={{ color: '#474747' }} />
                                                    </IconButton>
                                                }
                                            >
                                                {selectedFile}
                                            </Alert>
                                        </>

                                        :
                                        <>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                                style={{ color: '#474747', fontWeight: "400", fontSize: '16px' }}
                                            >
                                                You can upload JPG, PNG or PDF files. The max file size is 10mb.
                                            </Typography>
                                            <DragAndDropUpload onDrop={handleDrop} fileType="image" />
                                        </>

                                    }
                                    {organisationErrors?.image &&
                                        <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${organisationErrors?.image}`}</FormHelperText>
                                    }
                                </Box>
                                <Box sx={{ width: "100%", mt: 2 }}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        style={{ color: '#474747', fontWeight: "400", fontSize: '16px' }}
                                    >
                                        Primary Color
                                    </Typography>
                                    {colors.map((color, index) => (
                                        <IconButton key={index} onClick={() => handleSelectPrimaryColor(color)} sx={{ margin: '0px 10px 0px 0px', padding: '0px' }}>
                                            {organisationDetail?.theme_color === color ? (
                                                <FaCircleCheck style={{ color, fontSize: "x-large" }} />
                                            ) : (
                                                <FaCircle style={{ color, fontSize: "x-large" }} />
                                            )}
                                        </IconButton>
                                    ))}
                                    {organisationErrors?.theme_color &&
                                        <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${organisationErrors?.theme_color}`}</FormHelperText>
                                    }
                                </Box>

                                <Button onClick={handleSubmitOrganisation}>
                                    Save and Continue
                                </Button>
                                <Button onClick={() => {
                                    setActiveStep(1.1)
                                    setSelectedFile(null);
                                    setOrganisationDetail((prevState) => ({
                                        ...prevState,
                                        admin_name: '',
                                        'image': ''
                                    }));
                                    setOrganisationErrors({});
                                }} variant='outlined' sx={{
                                    marginRight: '20px',
                                    color: `${newtheme?.customSettings?.themeColor}`,
                                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                    background: 'none'
                                }}>
                                    Back
                                </Button>
                            </Grid2>
                        }
                        {activeStep === 3.5 &&
                            <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }}>
                                <Typography
                                    variant="h3"
                                    gutterBottom
                                    sx={{
                                        mt: 4
                                    }}
                                    style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginBottom: "20px" }}
                                >
                                    Administrator Info
                                </Typography>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginBottom: "20px", textAlign: 'justify' }}
                                >
                                    Please provide the name of the SPOC contact who will serve as the point of contact, along with the administrator account that has full management permissions for PMIS tool.
                                </Typography>
                                <Box sx={{ width: "100%", mt: 2 }}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        style={{ color: '#696969', fontWeight: "500", fontSize: '20px' }}
                                    >
                                        SPOC Information
                                    </Typography>
                                    <SnackbarComponent message={"Please provide the details for the SPOC. This will serve as your point of contact."} />
                                    <Grid2 container spacing={2}>
                                        <Grid2 size={12}>
                                            <TextField
                                                label="Full Name"
                                                variant="filled"
                                                fullWidth
                                                placeholder="Ex: Roshan Patel"
                                                name="SPOC_name"
                                                value={administratorInfo?.SPOC_name}
                                                onChange={handleAdministratorInfo}
                                                onBlur={(event) => handleValidateAdministratorBlur(event, 'Full Name')}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                            />
                                            {fromError?.SPOC_name &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.SPOC_name}`}</FormHelperText>
                                            }
                                        </Grid2>

                                        <Grid2 size={7}>
                                            <TextField
                                                label="Work Email"
                                                variant="filled"
                                                fullWidth
                                                placeholder="Ex: roshanpatel@example.com"
                                                name="SPOC_email"
                                                value={administratorInfo?.SPOC_email}
                                                onChange={handleAdministratorInfo}
                                                onBlur={(event) => handleValidateAdministratorBlur(event, 'Work Email')}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                            />
                                            {fromError?.SPOC_email &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.SPOC_email}`}</FormHelperText>
                                            }
                                        </Grid2>
                                        <Grid2 size={5}>
                                            <TextField
                                                label="Phone Number"
                                                variant="filled"
                                                fullWidth
                                                placeholder="Ex: +48692462966"
                                                name="SPOC_phoneno"
                                                value={administratorInfo?.SPOC_phoneno}
                                                onChange={handleAdministratorInfo}
                                                onBlur={(event) => handleValidateAdministratorBlur(event, 'Phone Number')}
                                                slotProps={{ inputLabel: { shrink: true } }}
                                            />
                                            {fromError?.SPOC_phoneno &&
                                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.SPOC_phoneno}`}</FormHelperText>
                                            }
                                        </Grid2>
                                    </Grid2>
                                </Box>
                                <Box sx={{ width: "100%", mt: 2 }}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        style={{ color: '#696969', fontWeight: "500", fontSize: '20px' }}
                                    >
                                        Administrator User Information
                                    </Typography>
                                      <Grid2 size={12} style={{ display: 'flex', alignItems: 'center',marginBottom:'10px' }}>
                                        <Checkbox
                                            onChange={handleCheckboxChange} checked={isSameAddress} sx={{ p: 0, marginRight: '15px', '& .MuiSvgIcon-root': { fontSize: 20, color: `${newtheme?.customSettings?.themeColor}` } }} />
                                        <SnackbarComponent message={"Same as above. This user will have full administrative permissions."} />
                                    </Grid2>
                                    {!isSameAddress &&
                                        <Grid2 container spacing={2}>
                                            <Grid2 size={12}>
                                                <TextField
                                                    disabled={isSameAddress}
                                                    label="Full Name"
                                                    variant="filled"
                                                    fullWidth
                                                    placeholder="Ex: Roshan Patel"
                                                    name="tenantName"
                                                    defaultValue={administratorInfo?.tenantName}
                                                    value={administratorInfo?.tenantName}
                                                    onChange={handleAdministratorInfo}
                                                    onBlur={(event) => handleValidateAdministratorBlur(event, 'Full Name')}
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                />
                                                {fromError?.tenantName &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.tenantName}`}</FormHelperText>
                                                }
                                            </Grid2>

                                            <Grid2 size={7}>
                                                <TextField
                                                    disabled={isSameAddress}
                                                    label="Work Email"
                                                    variant="filled"
                                                    fullWidth
                                                    placeholder="Ex: roshanpatel@example.com"
                                                    name="tenantEmail"
                                                    value={administratorInfo?.tenantEmail}
                                                    defaultValue={administratorInfo?.tenantEmail}
                                                    onChange={handleAdministratorInfo}
                                                    onBlur={(event) => handleValidateAdministratorBlur(event, 'Work Email')}
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                />
                                                {fromError?.tenantEmail &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.tenantEmail}`}</FormHelperText>
                                                }
                                            </Grid2>
                                            <Grid2 size={5}>
                                                <TextField
                                                    disabled={isSameAddress}
                                                    label="Phone Number"
                                                    variant="filled"
                                                    fullWidth
                                                    placeholder="Ex: +48692462966"
                                                    name="tenantPhone"
                                                    defaultValue={administratorInfo?.tenantPhone}
                                                    value={administratorInfo?.tenantPhone}
                                                    onChange={handleAdministratorInfo}
                                                    onBlur={(event) => handleValidateAdministratorBlur(event, 'Phone Number')}
                                                    slotProps={{ inputLabel: { shrink: true } }}
                                                />
                                                {fromError?.tenantPhone &&
                                                    <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${fromError?.tenantPhone}`}</FormHelperText>
                                                }
                                            </Grid2>
                                        </Grid2>
                                    }

                                </Box>

                                <Button onClick={handleSubmit} disabled={isLoading}>
                                    {isLoading ? "Submitting..." : "Save and Continue"}
                                </Button>
                                <Button onClick={() => {
                                    setActiveStep(2.5)
                                    setFormError({
                                        ...intitalFormError
                                    });
                                    setIsSameAddress(false)
                                    setAdministratorInfo({
                                        'SPOC_name': "",
                                        'SPOC_email': "",
                                        'SPOC_phoneno': "",
                                        'tenantName': "",
                                        'tenantEmail': "",
                                        'tenantPhone': ""
                                    })
                                }} variant='outlined' sx={{
                                    marginRight: '20px',
                                    color: `${newtheme?.customSettings?.themeColor}`,
                                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                                    background: 'none'
                                }}>
                                    Back
                                </Button>
                            </Grid2>
                        }
                        {activeStep === 4 &&
                            <Grid2 size={{ xs: 12, md: 6 }} offset={{ md: 3 }} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', // Centers items horizontally
                                justifyContent: 'center', // Centers items vertically
                                mt: 4
                            }}>
                                {/* <img
                                    srcSet={`${checkLogo}`}
                                    src={`${checkLogo}`}
                                    alt={'pattern'}
                                    loading="lazy"
                                    style={{ width: '85px', height: "85px" }} // Ensure the image fills the container
                                /> */}
                                <CiCircleCheck style={{
                                    fontSize: '10rem',
                                    color: `${newtheme?.customSettings?.themeColor}`
                                }} />
                                <Typography
                                    variant="h3"
                                    gutterBottom
                                    style={{ color: '#696969', fontWeight: "500", fontSize: '24px', marginTop: "20px" }}
                                >
                                    Registration Completed
                                </Typography>
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    textAlign={"center"}
                                    style={{ color: '#474747', fontWeight: "400", fontSize: '16px', marginTop: "10px" }}
                                >
                                    Congrats! your product key is validated, with the Pwc PMIS tool. Check both emails for your administrator username and temporary password. Welcome on board!
                                </Typography>

                                <Button onClick={handleRedirect}>
                                    Login
                                </Button>
                            </Grid2>
                        }
                    </Grid2>
                </Box>
            </ThemeProvider>
        </>
    )
}

export default SignUp